<template>
  <div>
    <div class="center-content justify-center align-center">
      <template v-if="status=='home'">
        <h1 class="big-title text-center">Flying Finger</h1>
        <h1>Ranking</h1>
        <v-card
          class="ranking mt-4"
          width="200"
        >
          <v-card-text>
            <v-row
              v-for="(record,recordKey) in records"
              :key="recordKey"
            >
              <v-col
                class="py-0"
                cols="8"
              >{{record.name}}</v-col>
              <v-col
                class="py-0 text-right"
                cols="4"
              >{{record.score}}</v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-btn
          min-width="130"
          @click="indexStart()"
          class="mt-5 primary"
        >Go</v-btn>
        <!-- <div class="mt-5"> -->
        <div
          class="justify-center align-center mt-10 d-flex"
          style="width:100%;"
        >
          <router-link
            to="/top100"
            class="px-5"
          >Rank Top 100</router-link>
          <router-link
            to="/about"
            class="px-5"
          >About</router-link>
          <router-link
            to="/alltypings"
            class="px-5"
          >All Typings</router-link>
        </div>
        <!-- <v-btn
          min-width="130"
          to="/top100"
          class="mt-5"
        >Rank Top 100</v-btn> -->
      </template>
      <template v-else-if="status=='nameset'">
        <div>
          <form @submit.prevent="usernameSubmit()">
            <v-text-field
              label="Your Name?"
              full-width
              autofocus
              autocomplete="off"
              v-model="input.username"
            ></v-text-field>
          </form>
        </div>
      </template>
      <template v-else-if="status=='counting'">
        <h1 class="big-title text-center">{{countingNumber}}</h1>
      </template>
      <template v-else-if="status=='start'">
        <h1 class="text-center">{{ingText}}</h1>
        <v-form
          ref="answerForm"
          @submit.prevent="textInputSubmit()"
          :lazy-validation="false"
        >
          <v-text-field
            :rules="answerInputRules"
            full-width
            autofocus
            v-model="textInput"
          ></v-text-field>
        </v-form>
        <h3 class="text-center">{{answers.length+1}}/{{totalAnswerCount}}</h3>
      </template>
      <template v-else-if="status=='finish'">
        <h3>Your Score</h3>
        <h1>{{_score}}</h1>
        <div class="mt-5">
          <v-btn @click="restart()">One More Time</v-btn>
          <v-btn
            @click="backHome()"
            class="ml-5"
          >Back Home</v-btn>
        </div>
      </template>
    </div>
    <!-- <v-footer
      v-if="status=='home'"
      padless
      fixed
    >
      <v-col
        class="text-center"
        cols="12"
      >
        <router-link to="/top100">Top Rank 100</router-link>
        <router-link
          to="/addtyping"
          class="ml-5"
        >Add Typing</router-link>
      </v-col>
    </v-footer> -->
  </div>
</template>

<script>
import firebase from "@/firebase";
import moment from "moment";
export default {
  data() {
    return {
      rankLimit: 10,
      status: "home",
      input: {
        username: "",
      },
      myRecords: [],
      countingNumberStart: 3,
      countingNumber: 0,
      totalAnswerCount: 10,
      answers: [],
      startInterval: null,
      textInput: "",
      ingText: "",
      answerTimeStart: null,
      baseScore: 1000000,
      answerInputRules: [
        (value) => !!value || "Required.",
        (value) => value == this.ingText || "Not correct",
      ],
      records: [],
    };
  },
  computed: {
    _types() {
      return this.$store.state.types;
    },
    _score() {
      let totalScore = 0;
      this.answers.forEach((answer) => {
        totalScore +=
          (this.baseScore * (answer.text.length / 20 + 1)) /
          (answer.time - 500);
      });
      totalScore /= this.answers.length;
      return Math.round(totalScore);
    },
    _username() {
      return this.$store.state.username;
    },
  },
  methods: {
    indexStart() {
      if (!this._username) {
        this.status = "nameset";
      } else {
        this.status = "counting";
      }
    },
    backHome() {
      this.status = "home";
    },
    restart() {
      this.status = "counting";
    },
    textInputSubmit() {
      if (!this.$refs.answerForm.validate()) {
        return;
      }
      let answerTimeStart = moment();
      this.answers.push({
        text: this.textInput,
        time: answerTimeStart.diff(this.answerTimeStart),
      });
      this.$refs.answerForm.reset();
      if (this.answers.length >= this.totalAnswerCount) {
        this.textInput = "";
        this.status = "finish";
        return;
      } else {
        this.ingTextSet();
        this.textInput = "";
        return;
      }
    },
    usernameSubmit() {
      if (!this.input.username) {
        return;
      }
      this.$store.dispatch("updateUsername", this.input.username);
      this.status = "counting";
    },
    countingStart() {
      this.answers = [];
      this.countingNumber = this.countingNumberStart;
      this.startInterval = setInterval(() => {
        this.countingAct();
      }, 1000);
    },
    countingAct() {
      if (this.countingNumber - 1 <= 0) {
        this.status = "start";
        clearInterval(this.startInterval);
      } else {
        this.countingNumber--;
      }
    },
    ingTextSet() {
      const index = Math.floor(this._types.length * Math.random());
      this.ingText = this._types[index];
      this.answerTimeStart = moment();
    },
    async recordsGet() {
      this.records = [];
      const snapshot = await firebase.db
        .collection("records")
        .limit(this.rankLimit)
        .orderBy("score", "desc")
        .get();
      snapshot.forEach((record) => {
        this.records.push(record.data());
      });
    },
  },
  async mounted() {
    this.recordsGet();
  },
  watch: {
    status: {
      handler() {
        if (this.status == "home") {
          this.recordsGet();
        } else if (this.status == "counting") {
          this.countingStart();
        } else if (this.status == "start") {
          this.ingTextSet();
        } else if (this.status == "finish") {
          setTimeout(() => {
            firebase.db.collection("records").add({
              name: this.$store.state.username,
              score: this._score,
              create_at: new Date(),
            });
            this.myRecords.push(this._score);
          }, 50);
        }
      },
    },
  },
};
</script>